import { ROUTES } from '@dashboard/router/routeNames'
import type { RouteLocationNamedRaw } from 'vue-router'
import type { DetailView } from '../types/details'

/** Each details page's route and its name, which is also its page title. */
export const DETAIL_PAGES: Record<DetailView, { route: string; name: string }> = {
  audience: { route: ROUTES.DASHBOARD_AUDIENCE, name: 'Audience breakdown' },
  website: { route: ROUTES.DASHBOARD_WEBSITE, name: 'Website stats' },
  conversions: { route: ROUTES.DASHBOARD_CONVERSIONS, name: 'Conversions by page' }
}

export type OtherDashboard = {
  name: string
  to: RouteLocationNamedRaw
  /** Set on details pages, which open on a saved 7, 14 or 30 day range; Revenue keeps its own period. */
  view?: DetailView
}

const detailPage = (view: DetailView): OtherDashboard => ({
  name: DETAIL_PAGES[view].name,
  to: { name: DETAIL_PAGES[view].route },
  view
})

/** The dashboards beside the main one, in the order the Dashboard's footer and the sidebar list them. */
export const OTHER_DASHBOARDS: readonly OtherDashboard[] = [
  detailPage('audience'),
  { name: 'Revenue', to: { name: ROUTES.REVENUE } },
  detailPage('website'),
  detailPage('conversions')
]
